"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultExportColumns = exports.ExportColumns_Default_PeerToPeer = exports.ExportColumns_Default_All = exports.ExportColumns_Default_Base = exports.exportTotalTaxesColumnLabels = exports.getGuestListExportColumns = exports.getPaymentExportColumns = exports.guestListExportStatusLabels = exports.sweepstakesEntryExportStatusLabels = exports.addOnRedemptionStatusLabels = exports.fulfillmentExportDeliveryLabels = exports.fulfillmentExportStatusLabels = exports.getFulfillmentExportColumns = void 0;
const enums_1 = require("../../enums");
const export_1 = require("../../enums/export");
const fulfillment_1 = require("../../enums/fulfillment");
const locales_1 = require("../enums/locales");
const paymentExportColumnsConfig = ({ exportFormType, exportType, timezone, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const isAllForms = exportFormType === export_1.ExportFormType.AllForms;
    const isEvent = exportFormType === export_1.ExportFormType.Event;
    const isCustom = exportFormType === export_1.ExportFormType.Custom;
    const isDrawing = exportFormType === export_1.ExportFormType.Raffle || exportFormType === export_1.ExportFormType.Sweepstakes;
    const isAuction = exportFormType === export_1.ExportFormType.Auction;
    const isMembership = exportFormType === export_1.ExportFormType.Membership;
    const isPeerToPeer = exportFormType === export_1.ExportFormType.PeerToPeer;
    const isDonationFormOrCampaign = exportFormType === export_1.ExportFormType.DonationForm || exportFormType === export_1.ExportFormType.PeerToPeer;
    return {
        // Détails de la transaction
        transactionDetail: {
            createdAt: {
                formatLabel: (labels) => labels.split("(")?.[0],
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: `Date du paiement (${timezone})`,
                    [locales_1.Locales.EN]: `Payment Date (${timezone})`,
                    [locales_1.Locales.ES]: `Fecha de pago (${timezone})`,
                    [locales_1.Locales.DE]: `Zahlungsdatum (${timezone})`,
                },
            },
            createdAtTimestamp: {
                formatLabel: (labels) => labels.split("(")?.[0],
                hidden: true,
                labels: {
                    [locales_1.Locales.FR]: `Heure du paiement (${timezone})`,
                    [locales_1.Locales.EN]: `Payment Time (${timezone})`,
                    [locales_1.Locales.ES]: `Hora del pago (${timezone})`,
                    [locales_1.Locales.DE]: `Zahlungszeit (${timezone})`,
                },
            },
            totalAmount: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Montant total",
                    [locales_1.Locales.EN]: "Total Amount",
                    [locales_1.Locales.ES]: "Monto total",
                    [locales_1.Locales.DE]: "Gesamtbetrag",
                },
            },
            dafProvider: {
                hidden: !canRecordDaf,
                labels: {
                    [locales_1.Locales.FR]: "Fournisseur DAF",
                    [locales_1.Locales.EN]: "DAF provider",
                    [locales_1.Locales.ES]: "Proveedor DAF",
                    [locales_1.Locales.DE]: "DAF-Anbieter",
                },
            },
            paymentMethod: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Méthode de paiement",
                    [locales_1.Locales.EN]: "Payment Method",
                    [locales_1.Locales.ES]: "Método de pago",
                    [locales_1.Locales.DE]: "Zahlungsmethode",
                },
            },
            status: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Statut du paiement",
                    [locales_1.Locales.EN]: "Payment Status",
                    [locales_1.Locales.ES]: "Estado del pago",
                    [locales_1.Locales.DE]: "Zahlungsstatus",
                },
            },
            payoutDate: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Date de versement",
                    [locales_1.Locales.EN]: "Payout Date",
                    [locales_1.Locales.ES]: "Fecha de desembolso",
                    [locales_1.Locales.DE]: "Auszahlungsdatum",
                },
            },
            extraDonation: {
                hidden: isDonationFormOrCampaign || exportType === export_1.ExportPaymentsType.ItemizedPayments,
                tooltip: "exportModal.tooltip.extraDonation",
                labels: {
                    [locales_1.Locales.FR]: "Don additionnel",
                    [locales_1.Locales.EN]: "Extra Donation",
                    [locales_1.Locales.ES]: "Donación extra",
                    [locales_1.Locales.DE]: "Zusätzliche Spende",
                },
            },
            refundedAmount: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Montant remboursé",
                    [locales_1.Locales.EN]: "Refund Amount",
                    [locales_1.Locales.ES]: "Monto reembolsado",
                    [locales_1.Locales.DE]: "Erstattungsbetrag",
                },
            },
            recurringStatus: {
                tooltip: isDonationFormOrCampaign ? "exportModal.tooltip.frequency" : "exportModal.tooltip.recurringStatus",
                hidden: !(isMembership || isDonationFormOrCampaign || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Statut récurrent",
                    [locales_1.Locales.EN]: "Recurring Status",
                    [locales_1.Locales.ES]: "Estado recurrente",
                    [locales_1.Locales.DE]: "Wiederkehrender Status",
                },
            },
            discount: {
                hidden: isDonationFormOrCampaign || isAuction,
                labels: {
                    [locales_1.Locales.FR]: "Code de réduction",
                    [locales_1.Locales.EN]: "Discount",
                    [locales_1.Locales.ES]: "Descuento",
                    [locales_1.Locales.DE]: "Rabatt",
                },
            },
            taxes: {
                hidden: isDonationFormOrCampaign,
                tooltip: "exportModal.tooltip.taxes",
                labels: {
                    [locales_1.Locales.FR]: "Taxes de vente",
                    [locales_1.Locales.EN]: "Sales taxes",
                    [locales_1.Locales.ES]: "Impuestos sobre las ventas",
                    [locales_1.Locales.DE]: "Umsatzsteuern",
                },
            },
            selectedFund: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Fonds",
                    [locales_1.Locales.EN]: "Fund",
                    [locales_1.Locales.ES]: "Fondo",
                    [locales_1.Locales.DE]: "Fonds",
                },
            },
        },
        // Informations de l'acheteur
        buyerInfo: {
            firstName: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Prénom",
                    [locales_1.Locales.EN]: "First Name",
                    [locales_1.Locales.ES]: "Nombre",
                    [locales_1.Locales.DE]: "Vorname",
                },
            },
            lastName: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Nom",
                    [locales_1.Locales.EN]: "Last Name",
                    [locales_1.Locales.ES]: "Apellido",
                    [locales_1.Locales.DE]: "Nachname",
                },
            },
            email: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Courriel",
                    [locales_1.Locales.EN]: "Email",
                    [locales_1.Locales.ES]: "Correo electrónico",
                    [locales_1.Locales.DE]: "E-Mail",
                },
            },
            companyName: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Nom de l'entreprise",
                    [locales_1.Locales.EN]: "Company Name",
                    [locales_1.Locales.ES]: "Nombre de la empresa",
                    [locales_1.Locales.DE]: "Firmenname",
                },
            },
            address: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Adresse",
                    [locales_1.Locales.EN]: "Address",
                    [locales_1.Locales.ES]: "Dirección",
                    [locales_1.Locales.DE]: "Adresse",
                },
            },
            city: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Ville",
                    [locales_1.Locales.EN]: "City",
                    [locales_1.Locales.ES]: "Ciudad",
                    [locales_1.Locales.DE]: "Stadt",
                },
            },
            postalCode: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Code postal",
                    [locales_1.Locales.EN]: "Postal Code",
                    [locales_1.Locales.ES]: "Código postal",
                    [locales_1.Locales.DE]: "Postleitzahl",
                },
            },
            region: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Province",
                    [locales_1.Locales.EN]: "State",
                    [locales_1.Locales.ES]: "Estado",
                    [locales_1.Locales.DE]: "Bundesland",
                },
            },
            country: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Pays",
                    [locales_1.Locales.EN]: "Country",
                    [locales_1.Locales.ES]: "País",
                    [locales_1.Locales.DE]: "Land",
                },
            },
            locale: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Langue",
                    [locales_1.Locales.EN]: "Language",
                    [locales_1.Locales.ES]: "Idioma",
                    [locales_1.Locales.DE]: "Sprache",
                },
            },
        },
        // Informations fiscales et reçus
        taxReceiptInfo: {
            receiptNumber: {
                hidden: !canGenerateReceipt,
                labels: {
                    [locales_1.Locales.FR]: "N° de reçu fiscal",
                    [locales_1.Locales.EN]: "Tax Receipt #",
                    [locales_1.Locales.ES]: "# de recibo fiscal",
                    [locales_1.Locales.DE]: "Spendenbescheinigung Nr.",
                },
            },
            receiptUrl: {
                hidden: !canGenerateReceipt,
                labels: {
                    [locales_1.Locales.FR]: "URL du reçu fiscal",
                    [locales_1.Locales.EN]: "Tax Receipt URL",
                    [locales_1.Locales.ES]: "URL del recibo fiscal",
                    [locales_1.Locales.DE]: "Spendenbescheinigung-URL",
                },
            },
            eligibleAmount: {
                tooltip: "exportModal.tooltip.eligibleAmount",
                hidden: isDonationFormOrCampaign || !canGenerateReceipt,
                labels: {
                    [locales_1.Locales.FR]: "Montant admissible",
                    [locales_1.Locales.EN]: "Eligible Amount",
                    [locales_1.Locales.ES]: "Monto elegible",
                    [locales_1.Locales.DE]: "Abzugsfähiger Betrag",
                },
            },
        },
        // Informations sur les billets / articles
        ticketInfo: {
            details: {
                tooltip: "exportModal.tooltip.details",
                hidden: exportType === export_1.ExportPaymentsType.ItemizedPayments || isDonationFormOrCampaign,
                labels: {
                    [locales_1.Locales.FR]: "Détails",
                    [locales_1.Locales.EN]: "Details",
                    [locales_1.Locales.ES]: "Detalles",
                    [locales_1.Locales.DE]: "Details",
                },
            },
            rateTitle: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [locales_1.Locales.FR]: "Titre du tarif",
                    [locales_1.Locales.EN]: "Rate Title",
                    [locales_1.Locales.ES]: "Título de tarifa",
                    [locales_1.Locales.DE]: "Tarifbezeichnung",
                },
            },
            bidStatus: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || !(isAuction || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Statut",
                    [locales_1.Locales.EN]: "Status",
                    [locales_1.Locales.ES]: "Estado",
                    [locales_1.Locales.DE]: "Status",
                },
            },
            itemAmount: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [locales_1.Locales.FR]: "Montant de l'article",
                    [locales_1.Locales.EN]: "Item Amount",
                    [locales_1.Locales.ES]: "Monto del artículo",
                    [locales_1.Locales.DE]: "Artikelbetrag",
                },
            },
            ticketNumber: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [locales_1.Locales.FR]: "N° de billet",
                    [locales_1.Locales.EN]: "Ticket #",
                    [locales_1.Locales.ES]: "# de boleto",
                    [locales_1.Locales.DE]: "Ticket-Nr.",
                },
            },
            addOnNumber: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [locales_1.Locales.FR]: "N° d'extra",
                    [locales_1.Locales.EN]: "Add-on #",
                    [locales_1.Locales.ES]: "# de complemento",
                    [locales_1.Locales.DE]: "Add-on-Nr.",
                },
            },
            eTicketUrl: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign || isAuction,
                labels: {
                    [locales_1.Locales.FR]: "URL du billet électronique",
                    [locales_1.Locales.EN]: "E-ticket URL",
                    [locales_1.Locales.ES]: "URL del boleto electrónico",
                    [locales_1.Locales.DE]: "E-Ticket-URL",
                },
            },
            canceled: {
                hidden: exportType === export_1.ExportPaymentsType.Payments || isDonationFormOrCampaign,
                labels: {
                    [locales_1.Locales.FR]: "Billets annulés",
                    [locales_1.Locales.EN]: "Canceled Tickets",
                    [locales_1.Locales.ES]: "Boletos cancelados",
                    [locales_1.Locales.DE]: "Stornierte Tickets",
                },
            },
            occurrence: {
                tooltip: "exportModal.tooltip.occurrence",
                hidden: !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Occurrence",
                    [locales_1.Locales.EN]: "Occurrence",
                    [locales_1.Locales.ES]: "Ocurrencia",
                    [locales_1.Locales.DE]: "Termin",
                },
            },
            expirationDate: {
                tooltip: "exportModal.tooltip.expirationDate",
                hidden: !(isMembership || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Date d'expiration",
                    [locales_1.Locales.EN]: "Expiration Date",
                    [locales_1.Locales.ES]: "Fecha de vencimiento",
                    [locales_1.Locales.DE]: "Ablaufdatum",
                },
            },
            scans: {
                tooltip: "exportModal.tooltip.scans",
                hidden: exportType === export_1.ExportPaymentsType.Payments || !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Scans de billets",
                    [locales_1.Locales.EN]: "Ticket Scans",
                    [locales_1.Locales.ES]: "Escaneos de billetes",
                    [locales_1.Locales.DE]: "Ticket-Scans",
                },
            },
            lastScan: {
                tooltip: "exportModal.tooltip.lastScan",
                hidden: exportType === export_1.ExportPaymentsType.Payments || !(isEvent || isCustom || isDrawing || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "Dernier scan",
                    [locales_1.Locales.EN]: "Last Scan Date",
                    [locales_1.Locales.ES]: "Último escaneo",
                    [locales_1.Locales.DE]: "Letztes Scan-Datum",
                },
            },
        },
        // Informations sur le formulaire
        formInfo: {
            formTitle: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Titre de la campagne",
                    [locales_1.Locales.EN]: "Campaign Title",
                    [locales_1.Locales.ES]: "Título de la campaña",
                    [locales_1.Locales.DE]: "Kampagnentitel",
                },
            },
            formLink: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Lien de la campagne",
                    [locales_1.Locales.EN]: "Campaign Link",
                    [locales_1.Locales.ES]: "Enlace de la campaña",
                    [locales_1.Locales.DE]: "Kampagnenlink",
                },
            },
            campaignTitle: {
                tooltip: "exportModal.tooltip.campaignTitle",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [locales_1.Locales.FR]: "Titre de la campagne principale",
                    [locales_1.Locales.EN]: "Main Campaign Title",
                    [locales_1.Locales.ES]: "Título de la campaña principal",
                    [locales_1.Locales.DE]: "Titel der Hauptkampagne",
                },
            },
            teamTitle: {
                tooltip: "exportModal.tooltip.teamTitle",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [locales_1.Locales.FR]: "Titre de l'équipe",
                    [locales_1.Locales.EN]: "Team Title",
                    [locales_1.Locales.ES]: "Título del equipo",
                    [locales_1.Locales.DE]: "Teamname",
                },
            },
            teamCreationDate: {
                tooltip: "exportModal.tooltip.teamCreationDate",
                hidden: !(isPeerToPeer || isAllForms) || Boolean(hideCampaignInfo),
                labels: {
                    [locales_1.Locales.FR]: "Date de création de l'équipe",
                    [locales_1.Locales.EN]: "Team Creation Date",
                    [locales_1.Locales.ES]: "Fecha de creación del equipo",
                    [locales_1.Locales.DE]: "Team-Erstellungsdatum",
                },
            },
        },
        // Informations supplémentaires
        otherInfo: {
            note: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Note",
                    [locales_1.Locales.EN]: "Note",
                    [locales_1.Locales.ES]: "Nota",
                    [locales_1.Locales.DE]: "Notiz",
                },
            },
            inHonourName: {
                hidden: !(isDonationFormOrCampaign || isAllForms),
                labels: {
                    [locales_1.Locales.FR]: "En l'honneur ou à la mémoire de",
                    [locales_1.Locales.EN]: "In Honour/Memory of",
                    [locales_1.Locales.ES]: "En honor o en memoria de",
                    [locales_1.Locales.DE]: "Zu Ehren/Im Gedenken an",
                },
            },
            customQuestions: exportType === export_1.ExportPaymentsType.Payments
                ? {
                    hidden: false,
                    labels: {
                        [locales_1.Locales.FR]: "Questions pour l'acheteur",
                        [locales_1.Locales.EN]: "Buyer questions",
                        [locales_1.Locales.ES]: "Preguntas para el comprador",
                        [locales_1.Locales.DE]: "Fragen an Käufer",
                    },
                }
                : {
                    tooltip: "exportModal.tooltip.customQuestions",
                    hidden: false,
                    labels: {
                        [locales_1.Locales.FR]: "Questions personnalisées",
                        [locales_1.Locales.EN]: "Custom questions",
                        [locales_1.Locales.ES]: "Preguntas personalizadas",
                        [locales_1.Locales.DE]: "Benutzerdefinierte Fragen",
                    },
                },
            paymentHandler: {
                hidden: false,
                labels: {
                    [locales_1.Locales.FR]: "Responsable du paiement",
                    [locales_1.Locales.EN]: "Payment handler",
                    [locales_1.Locales.ES]: "Responsable del pago",
                    [locales_1.Locales.DE]: "Zahlungsverantwortliche(r)",
                },
            },
        },
    };
};
const guestListExportColumnsConfig = {
    guestFirstName: {
        labels: {
            [locales_1.Locales.FR]: "Prénom de l'invité",
            [locales_1.Locales.EN]: "Guest first name",
            [locales_1.Locales.ES]: "Nombre del invitado",
            [locales_1.Locales.DE]: "Vorname des Gastes",
        },
    },
    guestLastName: {
        labels: {
            [locales_1.Locales.FR]: "Nom de l'invité",
            [locales_1.Locales.EN]: "Guest last name",
            [locales_1.Locales.ES]: "Apellido del invitado",
            [locales_1.Locales.DE]: "Nachname des Gastes",
        },
    },
    guestEmail: {
        labels: {
            [locales_1.Locales.FR]: "Courriel de l'invité",
            [locales_1.Locales.EN]: "Guest email",
            [locales_1.Locales.ES]: "Correo electrónico del invitado",
            [locales_1.Locales.DE]: "E-Mail des Gastes",
        },
    },
    guestAddress: {
        labels: {
            [locales_1.Locales.FR]: "Adresse de l'invité",
            [locales_1.Locales.EN]: "Guest address",
            [locales_1.Locales.ES]: "Dirección del invitado",
            [locales_1.Locales.DE]: "Adresse des Gastes",
        },
    },
    guestCity: {
        labels: {
            [locales_1.Locales.FR]: "Ville de l'invité",
            [locales_1.Locales.EN]: "Guest city",
            [locales_1.Locales.ES]: "Ciudad del invitado",
            [locales_1.Locales.DE]: "Stadt des Gastes",
        },
    },
    guestRegion: {
        labels: {
            [locales_1.Locales.FR]: "Région de l'invité",
            [locales_1.Locales.EN]: "Guest region",
            [locales_1.Locales.ES]: "Región del invitado",
            [locales_1.Locales.DE]: "Region des Gastes",
        },
    },
    guestPostalCode: {
        labels: {
            [locales_1.Locales.FR]: "Code postal de l'invité",
            [locales_1.Locales.EN]: "Guest postal code",
            [locales_1.Locales.ES]: "Código postal del invitado",
            [locales_1.Locales.DE]: "Postleitzahl des Gastes",
        },
    },
    guestCountry: {
        labels: {
            [locales_1.Locales.FR]: "Pays de l'invité",
            [locales_1.Locales.EN]: "Guest country",
            [locales_1.Locales.ES]: "País del invitado",
            [locales_1.Locales.DE]: "Land des Gastes",
        },
    },
    buyerFirstName: {
        labels: {
            [locales_1.Locales.FR]: "Prénom de l'acheteur",
            [locales_1.Locales.EN]: "Buyer first name",
            [locales_1.Locales.ES]: "Nombre del comprador",
            [locales_1.Locales.DE]: "Vorname des Käufers",
        },
    },
    buyerLastName: {
        labels: {
            [locales_1.Locales.FR]: "Nom de l'acheteur",
            [locales_1.Locales.EN]: "Buyer last name",
            [locales_1.Locales.ES]: "Apellido del comprador",
            [locales_1.Locales.DE]: "Nachname des Käufers",
        },
    },
    buyerAddress: {
        labels: {
            [locales_1.Locales.FR]: "Adresse de l'acheteur",
            [locales_1.Locales.EN]: "Buyer address",
            [locales_1.Locales.ES]: "Dirección del comprador",
            [locales_1.Locales.DE]: "Adresse des Käufers",
        },
    },
    buyerCity: {
        labels: {
            [locales_1.Locales.FR]: "Ville de l'acheteur",
            [locales_1.Locales.EN]: "Buyer city",
            [locales_1.Locales.ES]: "Ciudad del comprador",
            [locales_1.Locales.DE]: "Stadt des Käufers",
        },
    },
    buyerRegion: {
        labels: {
            [locales_1.Locales.FR]: "Région de l'acheteur",
            [locales_1.Locales.EN]: "Buyer region",
            [locales_1.Locales.ES]: "Región del comprador",
            [locales_1.Locales.DE]: "Region des Käufers",
        },
    },
    buyerPostalCode: {
        labels: {
            [locales_1.Locales.FR]: "Code postal de l'acheteur",
            [locales_1.Locales.EN]: "Buyer postal code",
            [locales_1.Locales.ES]: "Código postal del comprador",
            [locales_1.Locales.DE]: "Postleitzahl des Käufers",
        },
    },
    buyerCountry: {
        labels: {
            [locales_1.Locales.FR]: "Pays de l'acheteur",
            [locales_1.Locales.EN]: "Buyer country",
            [locales_1.Locales.ES]: "País del comprador",
            [locales_1.Locales.DE]: "Land des Käufers",
        },
    },
    buyerEmail: {
        labels: {
            [locales_1.Locales.FR]: "Courriel de l'acheteur",
            [locales_1.Locales.EN]: "Buyer email",
            [locales_1.Locales.ES]: "Correo electrónico del comprador",
            [locales_1.Locales.DE]: "Käufer-E-Mail",
        },
    },
    ticketNumber: {
        labels: {
            [locales_1.Locales.FR]: "Numéro de billet",
            [locales_1.Locales.EN]: "Ticket number",
            [locales_1.Locales.ES]: "Número de boleto",
            [locales_1.Locales.DE]: "Ticketnummer",
        },
    },
    addOnNumber: {
        labels: {
            [locales_1.Locales.FR]: "Numéro d'extra",
            [locales_1.Locales.EN]: "Add-on number",
            [locales_1.Locales.ES]: "Número de complemento",
            [locales_1.Locales.DE]: "Add-on-Nummer",
        },
    },
    ticketType: {
        labels: {
            [locales_1.Locales.FR]: "Type de billet",
            [locales_1.Locales.EN]: "Ticket type",
            [locales_1.Locales.ES]: "Tipo de boleto",
            [locales_1.Locales.DE]: "Tickettyp",
        },
    },
    customQuestions: {
        labels: {
            [locales_1.Locales.FR]: "Questions personnalisées",
            [locales_1.Locales.EN]: "Custom questions",
            [locales_1.Locales.ES]: "Preguntas personalizadas",
            [locales_1.Locales.DE]: "Benutzerdefinierte Fragen",
        },
    },
    eventDate: {
        labels: {
            [locales_1.Locales.FR]: "Date de l'événement",
            [locales_1.Locales.EN]: "Event date",
            [locales_1.Locales.ES]: "Fecha del evento",
            [locales_1.Locales.DE]: "Veranstaltungsdatum",
        },
    },
    ticketNotes: {
        labels: {
            [locales_1.Locales.FR]: "Notes du billet",
            [locales_1.Locales.EN]: "Ticket notes",
            [locales_1.Locales.ES]: "Notas del boleto",
            [locales_1.Locales.DE]: "Ticketnotizen",
        },
    },
    status: {
        labels: {
            [locales_1.Locales.FR]: "Statut",
            [locales_1.Locales.EN]: "Status",
            [locales_1.Locales.ES]: "Estado",
            [locales_1.Locales.DE]: "Status",
        },
    },
};
const fulfillmentExportColumnsConfig = {
    buyerName: {
        labels: {
            [locales_1.Locales.FR]: "Nom de l'acheteur",
            [locales_1.Locales.EN]: "Buyer name",
            [locales_1.Locales.ES]: "Nombre completo del comprador",
            [locales_1.Locales.DE]: "Käufername",
        },
    },
    buyerEmail: {
        labels: {
            [locales_1.Locales.FR]: "Courriel de l'acheteur",
            [locales_1.Locales.EN]: "Buyer email",
            [locales_1.Locales.ES]: "Correo electrónico del comprador",
            [locales_1.Locales.DE]: "Käufer-E-Mail",
        },
    },
    items: {
        labels: {
            [locales_1.Locales.FR]: "Articles",
            [locales_1.Locales.EN]: "Items",
            [locales_1.Locales.ES]: "Artículos",
            [locales_1.Locales.DE]: "Artikel",
        },
    },
    questionsAndNotes: {
        labels: {
            [locales_1.Locales.FR]: "Questions et notes",
            [locales_1.Locales.EN]: "Questions and notes",
            [locales_1.Locales.ES]: "Preguntas y notas",
            [locales_1.Locales.DE]: "Fragen und Notizen",
        },
    },
    deliveryMethod: {
        labels: {
            [locales_1.Locales.FR]: "Mode de livraison",
            [locales_1.Locales.EN]: "Delivery method",
            [locales_1.Locales.ES]: "Método de entrega",
            [locales_1.Locales.DE]: "Liefermethode",
        },
    },
    fulfillmentStatus: {
        labels: {
            [locales_1.Locales.FR]: "Statut de traitement",
            [locales_1.Locales.EN]: "Fulfillment status",
            [locales_1.Locales.ES]: "Estado de cumplimiento",
            [locales_1.Locales.DE]: "Abwicklungsstatus",
        },
    },
    shippingAddress: {
        labels: {
            [locales_1.Locales.FR]: "Adresse de livraison",
            [locales_1.Locales.EN]: "Shipping address",
            [locales_1.Locales.ES]: "Dirección de envío",
            [locales_1.Locales.DE]: "Lieferadresse",
        },
    },
};
const getFulfillmentExportColumns = ({ locale, }) => {
    const columnsHeaders = Object.entries(fulfillmentExportColumnsConfig).reduce((acc, [key, value]) => {
        return { ...acc, [key]: value.labels[locale] };
    }, {});
    return { columnsHeaders };
};
exports.getFulfillmentExportColumns = getFulfillmentExportColumns;
const fulfillmentExportStatusLabels = (status) => {
    switch (status) {
        case fulfillment_1.CommandFulfillmentStatus.NotFulfilled:
            return {
                [locales_1.Locales.FR]: "Non traité",
                [locales_1.Locales.EN]: "Not fulfilled",
                [locales_1.Locales.ES]: "No cumplido",
                [locales_1.Locales.DE]: "Nicht abgewickelt",
            };
        case fulfillment_1.CommandFulfillmentStatus.PartiallyReady:
            return {
                [locales_1.Locales.FR]: "Partiellement prêt",
                [locales_1.Locales.EN]: "Partially ready",
                [locales_1.Locales.ES]: "Parcialmente listo",
                [locales_1.Locales.DE]: "Teilweise bereit",
            };
        case fulfillment_1.CommandFulfillmentStatus.Ready:
            return {
                [locales_1.Locales.FR]: "Prêt",
                [locales_1.Locales.EN]: "Ready",
                [locales_1.Locales.ES]: "Listo",
                [locales_1.Locales.DE]: "Bereit",
            };
        case fulfillment_1.CommandFulfillmentStatus.PartiallyFulfilled:
            return {
                [locales_1.Locales.FR]: "Partiellement traité",
                [locales_1.Locales.EN]: "Partially fulfilled",
                [locales_1.Locales.ES]: "Parcialmente cumplido",
                [locales_1.Locales.DE]: "Teilweise abgewickelt",
            };
        case fulfillment_1.CommandFulfillmentStatus.Fulfilled:
            return {
                [locales_1.Locales.FR]: "Traité",
                [locales_1.Locales.EN]: "Fulfilled",
                [locales_1.Locales.ES]: "Cumplido",
                [locales_1.Locales.DE]: "Abgewickelt",
            };
        default:
            return {
                [locales_1.Locales.FR]: "Inconnu",
                [locales_1.Locales.EN]: "Unknown",
                [locales_1.Locales.ES]: "Desconocido",
                [locales_1.Locales.DE]: "Unbekannt",
            };
    }
};
exports.fulfillmentExportStatusLabels = fulfillmentExportStatusLabels;
const fulfillmentExportDeliveryLabels = (method) => {
    switch (method) {
        case fulfillment_1.FulfillmentMethod.Pickup:
            return {
                [locales_1.Locales.FR]: "Cueillette",
                [locales_1.Locales.EN]: "Pick-up",
                [locales_1.Locales.ES]: "Recogida",
                [locales_1.Locales.DE]: "Abholung",
            };
        case fulfillment_1.FulfillmentMethod.Shipping:
            return {
                [locales_1.Locales.FR]: "Expédition",
                [locales_1.Locales.EN]: "Shipping",
                [locales_1.Locales.ES]: "Envío",
                [locales_1.Locales.DE]: "Versand",
            };
        default:
            return {
                [locales_1.Locales.FR]: "",
                [locales_1.Locales.EN]: "",
                [locales_1.Locales.ES]: "",
                [locales_1.Locales.DE]: "",
            };
    }
};
exports.fulfillmentExportDeliveryLabels = fulfillmentExportDeliveryLabels;
const CANCELED_LABELS = {
    [locales_1.Locales.FR]: "Annulé",
    [locales_1.Locales.EN]: "Canceled",
    [locales_1.Locales.ES]: "Cancelado",
    [locales_1.Locales.DE]: "Storniert",
};
const addOnRedemptionStatusLabels = (status) => {
    if (status === "checkedIn") {
        return {
            [locales_1.Locales.FR]: "Utilisé",
            [locales_1.Locales.EN]: "Redeemed",
            [locales_1.Locales.ES]: "Utilizado",
            [locales_1.Locales.DE]: "Eingelöst",
        };
    }
    if (status === "notCheckedIn") {
        return {
            [locales_1.Locales.FR]: "Non utilisé",
            [locales_1.Locales.EN]: "Not redeemed",
            [locales_1.Locales.ES]: "No utilizado",
            [locales_1.Locales.DE]: "Nicht eingelöst",
        };
    }
    return CANCELED_LABELS;
};
exports.addOnRedemptionStatusLabels = addOnRedemptionStatusLabels;
const sweepstakesEntryExportStatusLabels = (status) => {
    if (status === "canceled") {
        return CANCELED_LABELS;
    }
    return {
        [locales_1.Locales.FR]: "Active",
        [locales_1.Locales.EN]: "Active",
        [locales_1.Locales.ES]: "Activa",
        [locales_1.Locales.DE]: "Aktiv",
    };
};
exports.sweepstakesEntryExportStatusLabels = sweepstakesEntryExportStatusLabels;
const guestListExportStatusLabels = (status, formCategory) => {
    const isShop = formCategory === enums_1.FormCategory.Shop;
    if (status === "checkedIn") {
        return {
            [locales_1.Locales.FR]: isShop ? "Livré" : "Enregistré",
            [locales_1.Locales.EN]: isShop ? "Delivered" : "Checked-in",
            [locales_1.Locales.ES]: "Presente",
            [locales_1.Locales.DE]: isShop ? "Geliefert" : "Eingecheckt",
        };
    }
    if (status === "notCheckedIn") {
        return {
            [locales_1.Locales.FR]: isShop ? "Non livré" : "Non-enregistré",
            [locales_1.Locales.EN]: isShop ? "Not delivered" : "Not checked-in",
            [locales_1.Locales.ES]: "No presente",
            [locales_1.Locales.DE]: isShop ? "Nicht geliefert" : "Nicht eingecheckt",
        };
    }
    if (status === "canceled") {
        return CANCELED_LABELS;
    }
    return {
        [locales_1.Locales.FR]: "Inconnu",
        [locales_1.Locales.EN]: "Unknown",
        [locales_1.Locales.ES]: "Desconocido",
        [locales_1.Locales.DE]: "Unbekannt",
    };
};
exports.guestListExportStatusLabels = guestListExportStatusLabels;
const getPaymentExportColumns = ({ exportFormType, exportType, timezone, locale, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const config = paymentExportColumnsConfig({
        exportFormType,
        exportType,
        timezone,
        hideCampaignInfo,
        canGenerateReceipt,
        canRecordDaf,
    });
    const baseColumnsHeaders = Object.entries(config).reduce((acc, [_key, value]) => {
        const valueV = Object.entries(value).reduce((acc, [key, value]) => {
            if (value.hidden) {
                return acc;
            }
            return { ...acc, [key]: value.labels[locale] };
        }, {});
        return { ...acc, ...valueV };
    }, {});
    const createdAtTimestampConfig = config.transactionDetail.createdAtTimestamp;
    const columnsHeaders = Object.keys(baseColumnsHeaders).reduce((acc, key) => {
        acc[key] = baseColumnsHeaders[key];
        if (key === "createdAt" && createdAtTimestampConfig) {
            acc.createdAtTimestamp = createdAtTimestampConfig.labels[locale];
        }
        return acc;
    }, {});
    return { columnsHeaders, config };
};
exports.getPaymentExportColumns = getPaymentExportColumns;
const sweepstakesGuestListColumnLabels = {
    guestFirstName: {
        [locales_1.Locales.FR]: "Prénom du titulaire",
        [locales_1.Locales.EN]: "Entry holder first name",
        [locales_1.Locales.ES]: "Nombre del titular",
        [locales_1.Locales.DE]: "Vorname des Inhabers",
    },
    guestLastName: {
        [locales_1.Locales.FR]: "Nom du titulaire",
        [locales_1.Locales.EN]: "Entry holder last name",
        [locales_1.Locales.ES]: "Apellido del titular",
        [locales_1.Locales.DE]: "Nachname des Inhabers",
    },
    guestEmail: {
        [locales_1.Locales.FR]: "Courriel du titulaire",
        [locales_1.Locales.EN]: "Entry holder email",
        [locales_1.Locales.ES]: "Correo electrónico del titular",
        [locales_1.Locales.DE]: "E-Mail des Inhabers",
    },
    guestAddress: {
        [locales_1.Locales.FR]: "Adresse du titulaire",
        [locales_1.Locales.EN]: "Entry holder address",
        [locales_1.Locales.ES]: "Dirección del titular",
        [locales_1.Locales.DE]: "Adresse des Inhabers",
    },
    guestCity: {
        [locales_1.Locales.FR]: "Ville du titulaire",
        [locales_1.Locales.EN]: "Entry holder city",
        [locales_1.Locales.ES]: "Ciudad del titular",
        [locales_1.Locales.DE]: "Stadt des Inhabers",
    },
    guestRegion: {
        [locales_1.Locales.FR]: "Province/État du titulaire",
        [locales_1.Locales.EN]: "Entry holder region",
        [locales_1.Locales.ES]: "Región del titular",
        [locales_1.Locales.DE]: "Region des Inhabers",
    },
    guestPostalCode: {
        [locales_1.Locales.FR]: "Code postal du titulaire",
        [locales_1.Locales.EN]: "Entry holder postal code",
        [locales_1.Locales.ES]: "Código postal del titular",
        [locales_1.Locales.DE]: "Postleitzahl des Inhabers",
    },
    guestCountry: {
        [locales_1.Locales.FR]: "Pays du titulaire",
        [locales_1.Locales.EN]: "Entry holder country",
        [locales_1.Locales.ES]: "País del titular",
        [locales_1.Locales.DE]: "Land des Inhabers",
    },
    ticketNumber: {
        [locales_1.Locales.FR]: "Numéro de participation",
        [locales_1.Locales.EN]: "Entry number",
        [locales_1.Locales.ES]: "Número de participación",
        [locales_1.Locales.DE]: "Teilnahmenummer",
    },
    ticketType: {
        [locales_1.Locales.FR]: "Type de participation",
        [locales_1.Locales.EN]: "Entry type",
        [locales_1.Locales.ES]: "Tipo de participación",
        [locales_1.Locales.DE]: "Teilnahmeart",
    },
    ticketNotes: {
        [locales_1.Locales.FR]: "Notes de participation",
        [locales_1.Locales.EN]: "Entry notes",
        [locales_1.Locales.ES]: "Notas de la participación",
        [locales_1.Locales.DE]: "Teilnahmenotizen",
    },
};
const getGuestListExportColumns = ({ locale, formCategory, }) => {
    const isSweepstakes = formCategory === enums_1.FormCategory.Sweepstakes;
    const columnsHeaders = Object.entries(guestListExportColumnsConfig).reduce((acc, [key, value]) => {
        const sweepstakesLabels = isSweepstakes
            ? sweepstakesGuestListColumnLabels[key]
            : undefined;
        return { ...acc, [key]: (sweepstakesLabels ?? value.labels)[locale] };
    }, {});
    return { columnsHeaders };
};
exports.getGuestListExportColumns = getGuestListExportColumns;
exports.exportTotalTaxesColumnLabels = {
    [locales_1.Locales.FR]: "Total des taxes",
    [locales_1.Locales.EN]: "Total taxes",
    [locales_1.Locales.ES]: "Total de impuestos",
    [locales_1.Locales.DE]: "Steuern gesamt",
};
exports.ExportColumns_Default_Base = [
    "createdAt",
    "totalAmount",
    "paymentMethod",
    "dafProvider",
    "status",
    "payoutDate",
    "extraDonation",
    "refundedAmount",
    "recurringStatus",
    "firstName",
    "lastName",
    "companyName",
    "email",
    "receiptNumber",
    "receiptUrl",
    "eligibleAmount",
    "rateTitle",
    "itemAmount",
    "ticketNumber",
    "addOnNumber",
    "eTicketUrl",
    "canceled",
    "details",
    "note",
    "customQuestions",
    "taxes",
    "selectedFund",
];
exports.ExportColumns_Default_All = [...exports.ExportColumns_Default_Base, "formTitle"];
exports.ExportColumns_Default_PeerToPeer = [
    ...exports.ExportColumns_Default_Base,
    "formTitle",
    "formLink",
    "campaignTitle",
    "teamTitle",
];
const getDefaultExportColumns = ({ exportFormType, exportType, timezone, locale, hideCampaignInfo, canGenerateReceipt, canRecordDaf, }) => {
    const { columnsHeaders } = (0, exports.getPaymentExportColumns)({
        exportFormType,
        exportType,
        timezone,
        locale,
        hideCampaignInfo,
        canGenerateReceipt,
        canRecordDaf,
    });
    const displayedColumns = Object.keys(columnsHeaders);
    const defaultColumnsArray = exportFormType === export_1.ExportFormType.AllForms
        ? exports.ExportColumns_Default_All
        : exportFormType === export_1.ExportFormType.PeerToPeer
            ? exports.ExportColumns_Default_PeerToPeer
            : exports.ExportColumns_Default_Base;
    return displayedColumns.filter((key) => defaultColumnsArray.includes(key));
};
exports.getDefaultExportColumns = getDefaultExportColumns;
